import React from 'react';
import { GetDevices } from '../../containers/rtc/DeviceManagerContext';
import { RTC_DISPLAY_ASPECT_RATIO } from '../../services/rtc/constants';
import FixedAspectRatio from '../layout/FixedAspectRatio';
import AudioVisualisation from './AudioVisualisation';
import { BLUE_H } from 'app/constants/Colors';

const SoundCheck = () =>
  <GetDevices>{(devices) =>
    devices &&
    devices.audio.analyser && (
      <FixedAspectRatio aspectRatio={RTC_DISPLAY_ASPECT_RATIO}>
        <AudioVisualisation
          color={BLUE_H}
          analyser={devices.audio.analyser}
        />
      </FixedAspectRatio>
    )
  }</GetDevices>;

export default SoundCheck;
